import type { Directive, DirectiveBinding } from 'vue'

interface ClickOutsideElement extends HTMLElement {
  _clickOutside?: (event: MouseEvent) => void
}

export const clickOutside: Directive = {
  mounted(el: ClickOutsideElement, binding: DirectiveBinding) {
    el._clickOutside = (event: MouseEvent) => {
      const path = event.composedPath && event.composedPath()
      const isClickOutside = path 
        ? !path.includes(el)
        : !el.contains(event.target as Node)
        
      if (isClickOutside) {
        binding.value(event)
      }
    }
    
    setTimeout(() => {
      document.addEventListener('click', el._clickOutside!)
    }, 0)
  },
  
  unmounted(el: ClickOutsideElement) {
    if (el._clickOutside) {
      document.removeEventListener('click', el._clickOutside)
      delete el._clickOutside
    }
  }
}

// 导出 vue 插件
export const vClickOutside = {
  install(app: any) {
    app.directive('click-outside', clickOutside)
  }
} 